import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import camelcaseKeys from 'camelcase-keys'
import dayjs from 'dayjs'

import reserveApi from '../../../utils/axios'

import { AdminHeader } from '../Index'
import { AdminTd, AdminTh, AdminTable } from '../Tables'

// Create our number formatter.
const dollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
})

const percent = new Intl.NumberFormat('en-US', {
  style: 'percent',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2 // (causes 2500.99 to be printed as $2,501)
})

export const Payments = ({ short, userId = null }) => {
  const [payments, setPayments] = useState([])

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/admin/payments',
      params: {}
    }).then(response => {
      setPayments(camelcaseKeys(response.data, { deep: true }))
    })
  }, [userId])

  return (
    <div>
      {!short && <AdminHeader>Recent Payments</AdminHeader>}

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Email</AdminTh>
            <AdminTh>Date</AdminTh>
            <AdminTh>Amount</AdminTh>
            <AdminTh>Lifetime</AdminTh>
            <AdminTh>#</AdminTh>
            <AdminTh>Months</AdminTh>
            <AdminTh>Request</AdminTh>
            <AdminTh>Sms</AdminTh>
          </tr>
        </thead>
        <tbody>
          {payments.map((obj, index) => (
            <tr key={index} className={index % 2 !== 0 && 'bg-gray-50'}>
              <AdminTd>
                <Link to={`/admin/users/${obj.user?.id}`}>{obj.user.email}</Link>
              </AdminTd>

              <AdminTd>{dayjs(obj.createdAt).format('MM-DD')}</AdminTd>
              <AdminTd>{dollars.format(obj.total)}</AdminTd>
              <AdminTd>
                {dollars.format(obj.user.total)}
                {obj.user.payments.length > 1 && (
                  <span className="ml-2 text-xs text-gray-400">{dollars.format(obj.user.perMonth)}</span>
                )}
              </AdminTd>
              <AdminTd>{obj.user.payments.length}</AdminTd>

              <AdminTd>{parseInt(obj.user.age)}</AdminTd>
              <AdminTd>
                {obj.user.requestCountActive}
                <span className="ml-2 text-xs text-gray-400">{obj.user.requestCount}</span>
              </AdminTd>
              <AdminTd>
                {obj.user.smsCount}
                <span className="ml-2 text-xs text-gray-400">{obj.user.smsLimit}</span>
              </AdminTd>
            </tr>
          ))}
        </tbody>
      </AdminTable>
    </div>
  )
}

export default Payments
